export default {
  GET_RSEE_ABOUT_US_TEXT_LOADING: 'GET_RSEE_ABOUT_US_TEXT_LOADING',
  GET_RSEE_ABOUT_US_TEXT_SUCCESS: 'GET_RSEE_ABOUT_US_TEXT_SUCCESS',
  GET_RSEE_ABOUT_US_TEXT_FAILED: 'GET_RSEE_ABOUT_US_TEXT_FAILED',
  GET_RSEE_ABOUT_US_TEXT_REJECT: 'GET_RSEE_ABOUT_US_TEXT_REJECT',

  GET_ALL_CITIES_LOADING: 'GET_ALL_CITIES_LOADING',
  GET_ALL_CITIES_SUCCESS: 'GET_ALL_CITIES_SUCCESS',
  GET_ALL_CITIES_FAILED: 'GET_ALL_CITIES_FAILED',
  GET_ALL_CITIES_REJECT: 'GET_ALL_CITIES_REJECT',

  SET_CITY_CODE_LOADING: 'SET_CITY_CODE_LOADING',
  SET_CITY_CODE_SUCCESS: 'SET_CITY_CODE_SUCCESS',
  SET_CITY_CODE_FAILED: 'SET_CITY_CODE_FAILED',
  SET_CITY_CODE_REJECT: 'SET_CITY_CODE_REJECT',

  GET_AVATAR_LIST_SUCCESS: 'GET_AVATAR_LIST_SUCCESS',
  GET_AVATAR_LIST_LOADING: 'GET_AVATAR_LIST_LOADING',
  GET_AVATAR_LIST_REJECT: 'GET_AVATAR_LIST_REJECT',
  GET_AVATAR_LIST_FAILED: 'GET_AVATAR_LIST_FAILED',

  SET_USER_AVATAR_SUCCESS: 'SET_USER_AVATAR_SUCCESS',
  SET_USER_AVATAR_LOADING: 'SET_USER_AVATAR_LOADING',
  SET_USER_AVATAR_REJECT: 'SET_USER_AVATAR_REJECT',
  SET_USER_AVATAR_FAILED: 'SET_USER_AVATAR_FAILED',
};